import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/recursos_humanos/isr';
import Isr from './ISR';


const ms2p = (state) => {
  return {
    ...state.isr_rh,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Isr);